import { useCallback } from 'react'

import { type CoreItemCategory, type ParameterID } from '@flecto/types'

import { useFlattenItemCategories } from '../../../flecto-modules-saas/src/categories/hooks/useFlattenItemCategories'

export function useItemCategoriesInfo() {
  const { categories: itemCategories = [], isLoading } =
    useFlattenItemCategories()

  const getCategoryById = useCallback(
    (categoryId: ParameterID) => {
      return itemCategories?.find(
        (cat) => Number(categoryId) === Number(cat.id)
      )
    },
    [itemCategories]
  )

  const getCategoriesBreadcrumb = (
    categoryId: ParameterID
  ): CoreItemCategory[] => {
    const categories: CoreItemCategory[] = []
    const category = getCategoryById(categoryId)

    if (category) {
      categories.push(category)
    }

    const parent = itemCategories.filter(
      (item) => item.id === category?.parent_id
    )?.[0]

    if (parent) {
      categories.push(parent)
    }
    return categories.reverse()
  }

  const getCategoriesBreadcrumbNames = (categoryId?: ParameterID) => {
    if (!categoryId) {
      return ''
    }

    return (
      getCategoriesBreadcrumb(categoryId)
        .map((cat) => cat.name)
        .join(' > ') ?? ''
    )
  }

  return {
    getCategoriesBreadcrumb,
    getCategoriesBreadcrumbNames,
    getCategoryById,
    isLoading,
  }
}
